export const wideDesktopWidth = 1900;
export const desktopWidth = 1480;
export const wideTabletWidth = 950;
export const tabletWidth = 600;
export const wideMobileWidth = 400;
export const mobileWidth = 320;